import { useTheme } from '@mui/material';
// import zIndex from '@mui/material/styles/zIndex";
import { makeStyles } from '@mui/styles'

const windowHeight = window.innerHeight;
console.log("windowHeight.style INE............: ", windowHeight)
export const useStyles = makeStyles((theme) => ({
  wizardImg: {
    alignSelf: 'center !important',
    marginTop: theme.spacing(2),
    [theme.breakpoints.only('xs')]: {
      height: '40vh',
    },
    [theme.breakpoints.only('sm')]: {
      height: '40vh',
    },
    [theme.breakpoints.only('md')]: {
      height: '45vh',
    },
    [theme.breakpoints.only('lg')]: {
      height: '50vh',
    },
    [theme.breakpoints.only('xl')]: {
      height: '60vh',
    },
  },
  imgFinger: {
    padding: '1em',
    [theme.breakpoints.only('xs')]: {
      height: '40vh',
    },
    [theme.breakpoints.only('sm')]: {
      height: '40vh',
    },
    [theme.breakpoints.only('md')]: {
      height: '43vh',
    },
    [theme.breakpoints.only('lg')]: {
      height: '45vh',
    },
    [theme.breakpoints.only('xl')]: {
      height: '50vh',
    },
  },
  imgHelpCapture: {
    height: '33vh'
  },




  stageTitle: {
    width: '100%',
    paddingLeft: theme.spacing(1),
  },

  stageSubTitle: {
    width: '100%',
    paddingLeft: theme.spacing(1),
  },
  titlePrincipal: {
    fontWeight: 600,
    width: '100%',
    paddingLeft: theme.spacing(1),
    // fontSize: 24,
  },
  cargarDocsBtn: {
    width: '100%',
    alignSelf: 'center !important',
    marginBottom: '3px'
  },

  centerContentDialog: { //Help
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'space-between',
    alignItems: 'center',
    width: '60%',
    height: '85vh',
    position: 'relative',
    ['@media only screen and (max-width: 812px)']: {
      width: '90%',
      height: '83vh',
    }
  },

  imgHelp: { //Help
    height: '25vh',
    ['@media only screen and (max-width: 812px)']: {
      height: '21vh',
    }
  },

  imgHelp1: { //Help
    height: '30vh',
    ['@media only screen and (max-width: 812px)']: {
      height: '28vh',
    }
  },
  textContent: {
    fontWeight: 'bold !important',
    width: '100%',
    ['@media only screen and (max-width: 812px)']: {
      width: '90%',
    }
  },
  textContent1: {
    textAlign: 'justify',
    fontWeight: 'bold !important',
    width: '100%',
    ['@media only screen and (max-width: 812px)']: {
      width: '100%',
    }
  },
  instructiontoPopUp: { //Help
    marginLeft: theme.spacing(1),
    ['@media only screen and (max-width: 812px)']: {
      marginLeft: theme.spacing(0)
    }
  },

  //CAMERA:

  videoContainer: {
    position: 'relative',
    display: 'flex',
    alignContent: 'center',
    height: '100vh !important',
    backgroundColor: theme.palette.secondary.main,
    justifyContent: 'center'
  },

  photoContainer: {
    position: 'relative',
    display: 'flex',
    justifyContent: 'center',
    height: '100vh !important',
    backgroundColor: theme.palette.secondary.main
  },

  video: {
    width: '100% !important',
    height: '100vh !important',
  },

  img: {
    // width: '100% !important',
    // height: '95vh !important',
    backgroundSize: 'cover',
  },

  overlayContainer: {
    position: 'absolute !important',
    top: '0 !important',
    left: '0 !important',
    width: '100% !important',
    height: '100vh !important',
    display: 'flex !important',
    border: '10px white !important',
  },

  insideTextTip: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    position: 'absolute',
    top: '45vh',
    padding: '0.2rem',
    width: '100%',
    zIndex: '1000',
    borderRadius: '5px',
    ['@media only screen and (max-width: 800px)']: {
      top: '40vh',
    },
  },

  docIcon: {
    justifySelf: 'start',
    width: '5rem',
    ['@media only screen and (max-width: 800px)']: {
      width: '4rem',
    },
  },

  approvalSection: {
    height: '8%',
    width: '100%',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    alignSelf: 'flex-end',
    backgroundColor: theme.palette.primary.color,
  },

  iconApproval: {
    marginRight: theme.spacing(5),
    marginLeft: theme.spacing(5)
  },

  sectionToCapture: {
    height: '8%',
    width: '100%',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    alignSelf: 'flex-end',
    backgroundColor: theme.palette.primary.color,
  },

  sectionButtonBlick: {
    width: '100%',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    alignSelf: 'flex-end',
    backgroundColor: theme.palette.primary.color,
  },

  iconButton: {
    backgroundColor: '#ffffff !important',
    marginLeft: theme.spacing(2)
  },

  //Carousel

  wizardContainer: {
    width: '100% !important',
    height: '60vh',
    zIndex: 3,
    display: 'flex',
    alignItems: 'center',
    ['@media only screen and (max-width: 800px)']: {
      height: '65vh',
    },
    ['@media only screen and (max-width: 1080px) and (min-width: 800px)']: {
      height: '50vh',
    },
    marginBottom: theme.spacing(1),
    "& .swiper-pagination-container .swiper-pagination-dot__default": {
      width: '12px !important',
      height: '12px !important',
      "&.active": {
        backgroundColor: `${theme.palette.primary.main} !important`,
      }
    },
  },

  carouselSection: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
  },

  carouselContainer: {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'space-between',
    width: '100%',
    height: '65vh',
    position: 'relative',
    // ['@media only screen and (max-width: 812px)']: {
    //   width: '90%',
    // }
  },

  imageCarousel: {
    width: '100%',
    height: '100%',
    ['@media only screen and (max-width: 800px)']: {
      width: '100%',
      height: 'auto',
      // marginTop: '12%',
    },
    // marginTop: theme.spacing(2),
    // ['@media only screen and (max-width: 800px)']: {
    //   height: '36vh',
    //   marginTop: theme.spacing(1),
    //   marginBottom: theme.spacing(2),
    // },
    // ['@media only screen and (max-width: 1080px) and (min-width: 800px)']: {
    //   height: '25vh',
    // },
  },
  imageCarouselSelfie: {
    width: '45%',
    height: '100%',
    // marginTop: '8%',
    ['@media only screen and (max-width: 800px)']: {
      width: '50%',
      height: 'inherit',
      // marginTop: '8%',
    },
  },

  imageCarDialog: {
    height: '55vh',
    marginBottom: theme.spacing(5),
    marginLeft: theme.spacing(1),
    marginRight: theme.spacing(1),
    ['@media only screen and (max-width: 800px)']: {
      height: '40vh',
    },
  },

  //Extraction Form

  form: {
    width: '100%',
    display: 'flex',
    flexDirection: 'column',
    overflowY: 'auto',
    overflowX: 'hidden',
    // height: '73vh',
    // margin: '0 24px',
    marginTop: '24px',
    '&::-webkit-scrollbar': {
      display: 'none',
    },
    ['@media only screen and (max-width: 800px)']: {
      height: '73vh !important',
      marginBottom: '48px',
    },
  },

  frame: {
    width: '100% !important',
    height: '32vh',
    border: 'solid 2px #A2A2A2',
    borderRadius: '15px',
    position: 'absolute',
    top: '30%',
    left: 0,
    zIndex: 1,
    ['@media only screen and (max-width: 800px)']: {
      left: '1rem',
      height: '48vh',
      top: '18%',
      width: '90% !important',
    },
    ['@media only screen and (max-width: 1080px) and (min-width: 800px)']: {
      height: '29vh',
      top: '32%',
      left: 0,
    },
  },

  inputs: {
    marginTop: '16px !important`',
    '& .MuiInput-root': {
      padding: '2px',
      display: 'flex !important',
      flexDirection: 'column !important',
      alignItems: 'center !important',
      justifyContent: 'center !important',
      height: '100% !important',
      borderRadius: '8px',
      border: `1px solid ${theme.palette.primary.border} !important`,
    },
    '&& ::before': {
      borderBottomColor: theme.palette.primary.border,
      borderBottom: `0px solid ${theme.palette.primary.border} !important`,
      paddingLeft: '10px',
    },
    '&& ::after': {
      borderRadius: '8px',
      borderBottomColor: theme.palette.primary.border,
      border: `2px solid ${theme.palette.primary.border} !important`,
    },
    '& .MuiInputLabel-animated': {
      paddingLeft: '10px',
      color: `${theme.palette.primary.border} !important`,
    },
    '& .MuiFormLabel-root.mui-focused': {
      color: `${theme.palette.primary.border} !important`,
      paddingLeft: '10px',
    },
    '& .MuiInputBase-input': {
      paddingLeft: '10px',
    }
  },

  inputSelect: { // Padding for select Inputs Material UI 
    margin: theme.spacing(1),
    "& .MuiSelect-outlined": {
      padding: 11
    }
  },

  inputFacialApproved: {
    margin: theme.spacing(1),
    "& .MuiInputBase-root.Mui-disabled": {
      color: theme.palette.primary.darkContrast,
      backgroundColor: theme.palette.success.main,
      marginTop: '0 !important'
    }
  },
  inputFacialRejected: {
    margin: theme.spacing(1),
    "& .MuiInputBase-root.Mui-disabled": {
      color: theme.palette.primary.darkContrast,
      backgroundColor: theme.palette.error.main,
      marginTop: '0 !important'
    }
  },

  inputFacialMedium: {
    margin: theme.spacing(1),
    "& .MuiInputBase-root.Mui-disabled": {
      color: theme.palette.warning.main,
      marginTop: '0 !important'
    }
  },

  facialResponseSection: {
    width: '95%'
  },
  facialText: {
    marginLeft: theme.spacing(1),
    fontSize: 12,
    fontWeight: 'bold !important'
  },

  text: {
    marginLeft: theme.spacing(1),
  },

  //HelpForm

  close: {
    alignSelf: 'flex-end !important',
    marginRight: theme.spacing(3),
    '&&:focus': {
      outline: 'none !important',
    },
    ['@media only screen and (max-width: 812px)']: {
      marginRight: theme.spacing(0),
    }

  },

  dialog: {
    minHeight: '100vh !important',
    maxHeight: '100vh !important',
  },

  centerSection: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
  },

  textSection: {
    width: '70%',
    ['@media only screen and (max-width: 812px)']: {
      width: '80%',
    }
  },

  helpImg: {
    height: '200px',
    marginBottom: theme.spacing(2),
    ['@media only screen and (max-width: 812px)']: {
      height: '170px',
    }
  },

  instructions: {
    marginBottom: theme.spacing(2),
    ['@media only screen and (max-width: 812px)']: {
      marginBottom: theme.spacing(1),
    }
  },

  //FingerSelection

  colorSecondary: {
    '&$checked': {
      color: theme.palette.primary.main,
    },
  },

  centerContent: {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'space-between',
    width: '60%',
    height: '87vh',
    position: 'relative',
    ['@media only screen and (max-width: 812px)']: {
      width: '90%',
      height: '78vh',
    }
  },

  section: {
    width: '100%',
  },

  sectionSkip: {
    width: '100%',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center'
  },

  iconHelp: {
    marginBottom: theme.spacing(1),
    marginLeft: theme.spacing(1),
  },

  textSkip: {
    marginBottom: theme.spacing(1),
    marginTop: theme.spacing(1),
    alignSelf: 'flex-start !important',
  },

  //FingerSelectHelp 
  containerHelp: {
    height: windowHeight < 670 ? '70vh' : '80vh',
    width: '100%',
    display: 'flex',
    marginTop: theme.spacing(2),
    ['@media only screen and (max-width: 600px)']: {
      height: '65vh',
    },
    ['@media only screen and (max-width: 800px) and (min-width: 600px)']: {
      height: windowHeight < 670 ? '65vh' : '74vh',
    },
    ['@media only screen and (max-width: 1080px) and (min-width: 800px)']: {
      height: '50vh',
    },
    marginBottom: theme.spacing(1),
    "& .swiper-pagination-container .swiper-pagination-dot__default": {
      width: '12px !important',
      height: '12px !important',
      "&.active": {
        backgroundColor: `${theme.palette.primary.main} !important`,
      }
    },
  },

  wizardTitle: {
    fontWeight: 600,
    alignSelf: 'flex-start !important'
  },

  wizardSubtitle: {
    alignSelf: 'flex-start !important',
    marginBottom: windowHeight < 670 ? '2px' : theme.spacing(2),
    marginTop: windowHeight < '670' ? '2px' : theme.spacing(2)
  },

  insideHelpContent: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    marginTop: theme.spacing(5),
    ['@media only screen and (max-width: 812px)']: {
      marginTop: theme.spacing(1),
    }
  },

  //ExternalValidation

  subTitle: {
    fontSize: 13,
    color: 'red !important',
    fontWeight: 'bold !important'
  },

  containerResult: {
    display: 'grid !important',
    gridTemplateColumns: '60% 20% 20%',
    // gridAutoRows: '100vh !important',
    overflowY: 'auto !important',
    backgroundColor: '#FFFFFF !important'
  },
  centerColumnResult: {
    display: 'flex',
    flexDirection: 'column !important',
    alignItems: 'center !important',
    '&::-webkit-scrollbar': {
      width: '0',  /* Remove scrollbar space */
      background: 'transparent',  /* Optional: just make scrollbar invisible */
    },
    overflowX: 'none',
  },
  leftColumnResult: {
    display: 'flex',
    flexDirection: 'column !important',
    alignItems: 'flex-start !important',
    overflowY: 'none',
    justifyContent: 'flex-start !important',
  },
  rightColumnResult: {
    display: 'flex',
    flexDirection: 'column !important',
    alignItems: 'flex-end !important',
    justifyContent: 'flex-start !important',
    overflowY: 'none',
  },
  helpIconRed: {
    color: 'red',
    marginLeft: '15%',
    marginRight: '15%',
    marginTop: '9.3%',
    ['@media only screen and (max-width: 812px)']: {
      marginTop: '12.9%',
    }
  },
  helpIconGreen: {
    color: 'green',
    marginLeft: '15%',
    marginRight: '15%',
    marginTop: '9.3%',
    ['@media only screen and (max-width: 812px)']: {
      marginTop: '12.9%',
    }
  },
  helpIconYellow: {
    color: '#FFC200',
    marginLeft: '15%',
    marginRight: '15%',
    marginTop: '9.3%',
    ['@media only screen and (max-width: 812px)']: {
      marginTop: '12.9%',
    }
  },

  helpIcon: {
    alignItems: 'center',
    justifyContent: 'center',
    margin: 5,
  },
  helpIconRed1: {
    color: 'red',
    alignItems: 'center',
    justifyContent: 'center',
    margin: 5,
  },
  helpIconGreen1: {
    color: 'green',
    alignItems: 'center',
    justifyContent: 'center',
    margin: 5,
  },
  helpIconYellow1: {
    color: '#FFC200',
    alignItems: 'center',
    justifyContent: 'center',
    margin: 5,
  },
  buttonsSection: {
    width: '100% !important'
  },
  centerContent1: {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'space-between',
    width: '60%',
    height: '87vh',
    position: 'relative',
    ['@media only screen and (max-width: 812px)']: {
      width: '90%',
      height: '78vh',
    }
  },
  centerContentExtract: {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'space-between',
    // width: '60%',
    // height: '87vh',
    position: 'relative',
    ['@media only screen and (max-width: 812px)']: {
      width: '100%',
      // height: '78vh',
    }
  },
  tableResult: {
    height: '110vh',
    overflow: 'hidden',
    ['@media only screen and (max-width: 812px)']: {
      height: 'auto',
    },
    // marginBottom: '3em !important'
  },
  btnCss: {
    display: 'flex',
    width: '100% !important',
    justifyContent: 'center',
    marginTop: '1% !important',
    fontWeight: 'bold',
  },
  carouselSection1: {
    marginTop: '40px',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    ['@media only screen and (max-width: 812px)']: {
      height: '30vh',
      marginTop: '40px',
    }
  },
  buttonWidths: {
    width: '100% !important'
  },
  carouselSection2: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    ['@media only screen and (max-width: 812px)']: {
      height: '67vh',
    }
  },
  wizardContainer1: {
    width: '100% !important',
    height: '72vh',
    zIndex: 3,
    display: 'flex',
    alignItems: 'center',
    ['@media only screen and (max-width: 800px)']: {
      height: '75vh',
    },
    marginBottom: theme.spacing(1),
    "& .swiper-pagination-container .swiper-pagination-dot__default": {
      width: '12px !important',
      height: '12px !important',
      "&.active": {
        backgroundColor: `${theme.palette.primary.main} !important`,
      }
    },
  },
  buttonContainerHelp: {
    // display: 'flex',
    // alignContent: 'center',
    width: '100% !important',
    textAlign: 'center',
  },
  mainContainerCapture: {
    display: 'flex',
    flexDirection: 'column !important',
    overflowY: 'auto',
    '&::-webkit-scrollbar': {
      width: '0',
      background: 'transparent',
    },
    overflowX: 'hidden',
    position: 'absolute',
    top: 0,
    bottom: 0,
    width: '100%',
  },
  containerCapture: {
    display: 'grid !important',
    height: '100vh !important',
    gridTemplateColumns: '100%',
    ['@media only screen and (max-width: 812px)']: {
      gridTemplateColumns: '100%',
    },
    gridAutoRows: '100vh !important',
    overflowY: 'hidden !important',
    backgroundColor: '#FFFFFF !important'
  },
  rootListItems: {
    '&.MuiList-padding': {
      padding: '0px !important'
    }
  },
  buttonList: {
    padding: '16px',
    gap: '16px',
    height: '56px',
    background: '#FCFCFC',
    border: '1px solid #F2F2F2',
    borderRadius: '8px',
  },
}))